import { Drawer } from 'antd';
import cx from 'classnames';
import React from 'react';

const CustomDrawer = (props) => {
  const { className, placement = 'right', width = 400, children, visible, ...res } = props;
  return (
    <Drawer rootClassName={cx('amondz-drawer', className)} placement={placement} width={width} open={visible} {...res}>
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
